import { useEffect } from "react";
import { useNavigate } from "react-router";

interface RedirectToProps {
  to: string;
  replace?: boolean;
}

export const RedirectTo = ({ to, replace = true }: RedirectToProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const isExternal = new URL(to).origin !== window.location.origin;
      if (isExternal) {
        window.location.replace(to);
      } else {
        navigate(to, { replace });
      }
    } catch {
      // If `to` is a relative URL or malformed absolute, fallback to internal redirect
      navigate(to, { replace });
    }
  }, [to, replace, navigate]);

  return null;
};
